// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ffM2","controls":"styles_controls__1D17K","charLimit":"styles_charLimit__1op3J","input":"styles_input__1J5jA","send":"styles_send__1aS-A"};